// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29PzS","title":"styles_title__2otSn"};